/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./instance.vue?vue&type=template&id=10353657&scoped=true&"
import script from "./instance.vue?vue&type=script&lang=js&"
export * from "./instance.vue?vue&type=script&lang=js&"
import style0 from "./instance.vue?vue&type=style&index=0&id=10353657&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10353657",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
